interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ChevronLeftIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M3.469,7.469C3.175,7.763 3.175,8.238 3.469,8.528L9.469,14.531C9.762,14.825 10.237,14.825 10.528,14.531C10.819,14.238 10.822,13.762 10.528,13.472L5.059,8.003L10.531,2.531C10.825,2.237 10.825,1.762 10.531,1.472C10.237,1.181 9.762,1.178 9.472,1.472L3.469,7.469Z" />
    </svg>
  );
}
